import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedManga from './components/FeaturedManga';
import StatsSection from './components/StatsSection';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedManga />
        <StatsSection />
        <LatestUpdates />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}